export type LeftSidebarMode = 'full' | 'close' | 'hidden' | 'compact' | 'mobile'

const Layout1SettingsChtc = {
  leftSidebar: {
    show: true,
    mode: 'full' as LeftSidebarMode,
    theme: 'white', // View all valid theme colors inside EgretTheme/themeColors.js
    bgOpacity: 0.1, // 0 ~ 1
    bgImgURL: '/assets/images/chtc-half-logo-bg.png',
    bgStyle: {
      backgroundSize: 'auto',
      backgroundPosition: 'left bottom',
      backgroundRepeat: 'no-repeat',
      color: 'rgba(255, 255, 255, 0.7)'
    },
    headerStyle: {}
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'white' // View all valid theme colors inside EgretTheme/themeColors.js
  },
  secondarySidebar: {
    show: false
  }

}

export default Layout1SettingsChtc

export type Layout1SettingsChtcType = typeof Layout1SettingsChtc
